import React, { Component } from 'react';
import DashboardJapaneseContent from '../function-components/DashboardJapaneseContent';

class DashboardJapanese extends Component {
    render() {
        return (
            <>
             <DashboardJapaneseContent/>   
            </>
        );
    }
}

export default DashboardJapanese;